import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createDailyTariffFailed, createDailyTariffSuccessful } from '../actions';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createDailyTariff(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/daily-tariffs`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK || dataResponse.status === CREATED) {
      yield put(createDailyTariffSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(createDailyTariffFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createDailyTariffFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
